import { schema } from './schema'
import { useNotifications } from '@components/NotificationsProvider'
import {
  ContactFormVariant,
  Gender,
  LeadType,
  SubmitContactFormMutationVariables,
  useSubmitContactFormMutation,
} from '@generated'
import { capitalizeWords } from '@lib/capitalize-words'
import { genericPushToTrackingLayer } from '@lib/data-layer-social-ads/generic-push-to-tracking-layer'
import { useRolexEventTracking } from '@lib/hooks/use-rolex-track-events'
import { Form, Formik } from 'formik'
import { useTranslation } from 'next-i18next'
import React, { FC } from 'react'

type RolexContactFormFormProps = {
  renderFields: React.ReactNode
  handleSuccessfullSubmit?: () => void
}

const personalFields = {
  gender: '',
  firstName: '',
  lastName: '',
  email: '',
  countryCode: '31',
  phone: '',
}

const locationFields = {
  location: '',
  store: '',
}

const messageCheckboxFields = {
  message: '',
  agree: false,
  subscribe: false,
}

export const RolexContactFormForm: FC<RolexContactFormFormProps> = ({
  renderFields,
  handleSuccessfullSubmit,
}) => {
  const notifications = useNotifications()
  const [, submitContactForm] = useSubmitContactFormMutation()
  const { t } = useTranslation(['rolex', 'navigation', 'notifications'])
  const { track } = useRolexEventTracking()

  return (
    <Formik
      validationSchema={schema}
      validateOnBlur
      validateOnChange
      initialValues={{
        ...personalFields,
        ...locationFields,
        ...messageCheckboxFields,
      }}
      onSubmit={async (values, { resetForm }) => {
        const { gender, firstName, lastName, email, phone, message, subscribe, store, location } =
          values

        let variables: SubmitContactFormMutationVariables = {
          input: {
            type: LeadType.Question,
            gender: gender as Gender,
            firstName: capitalizeWords(firstName),
            lastName: capitalizeWords(lastName),
            email,
            phone,
            subject: 'Vraag vanaf Rolex contact pagina',
            message,
            store,
            location,
            referrer: window.location.href,
            referrerTitle: document.title,
            variant: ContactFormVariant['Rolex'],
          },
          newsletterSignup: subscribe,
        }
        const { data, error } = await submitContactForm(variables)
        if (error) {
          if (process.env.NODE_ENV === 'development') {
            console.error(error)
          }
          notifications.addNotification({
            variant: 'error',
            label: t('refreshAndTryAgain', { ns: 'notifications' }),
          })
        }

        if (data) {
          notifications.addNotification({
            variant: 'confirmation',
            description: t('requestSent', { ns: 'notifications' }),
            label: t('weWillContactYou', { ns: 'notifications' }),
          })
          resetForm()
          handleSuccessfullSubmit()
          track('contactForm')
          genericPushToTrackingLayer('ContactForm', 'Send')
        }
      }}
    >
      <Form>{renderFields}</Form>
    </Formik>
  )
}
